var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNstreets(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 24,
    viewBox: "0 0 32 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_38",
    "data-name": "\\uC0AC\\uAC01\\uD615 38",
    width: 28.033,
    height: 14,
    fill: "#e4e4e4"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_36",
    "data-name": "\\uC0AC\\uAC01\\uD615 36",
    width: 17.521,
    height: 14,
    fill: "#e4e4e4"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_103",
    "data-name": "\\uADF8\\uB8F9 103",
    transform: "translate(-6 -22)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_66",
    "data-name": "\\uADF8\\uB8F9 66",
    transform: "translate(8.25 22)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_21",
    "data-name": "\\uD328\\uC2A4 21",
    d: "M9.812,0,0,14h4.2L11.073,0Z",
    transform: "translate(0 0)",
    fill: "#e4e4e4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_22",
    "data-name": "\\uD328\\uC2A4 22",
    d: "M27.83,0,34.7,14H38.9L29.091,0Z",
    transform: "translate(-10.87 0)",
    fill: "#e4e4e4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_65",
    "data-name": "\\uADF8\\uB8F9 65"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_64",
    "data-name": "\\uADF8\\uB8F9 64",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_63",
    "data-name": "\\uADF8\\uB8F9 63",
    transform: "translate(5.256)",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_62",
    "data-name": "\\uADF8\\uB8F9 62"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_61",
    "data-name": "\\uADF8\\uB8F9 61",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_23",
    "data-name": "\\uD328\\uC2A4 23",
    d: "M14.757,0,8.625,14H26.145L20.013,0Z",
    transform: "translate(-8.625)",
    fill: "#e4e4e4"
  }))))))), /*#__PURE__*/React.createElement("text", {
    id: "n_STREETS",
    "data-name": "n STREETS",
    transform: "translate(22 34)",
    fill: "#0062af",
    fontSize: 14,
    fontFamily: "NanumSquareB, NanumSquare",
    letterSpacing: "-0.05em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -4,
    y: 0
  }, "n"), /*#__PURE__*/React.createElement("tspan", {
    fill: "#fff",
    fontSize: 8
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -15,
    y: 10
  }, "STREETS"))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNstreets);
export default __webpack_public_path__ + "static/media/nstreets.684940b916023b908c9807e36a8eea86.svg";
export { ForwardRef as ReactComponent };